// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__cXr_J","errors":"Errors_errors__3-87u"};